import * as React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ThankYou from "./pages/ThankYou";
import Dashboard from "./pages/Dashboard/Dashboard";
import ProductPage from "./pages/ProductPage";
import Register from "./pages/Dashboard/Register";
import Login from "./pages/Dashboard/Login";
import PrivateRoute from "./pages/Dashboard/PrivateRoute";
import SingleCategory from "./pages/SingleCategory";
import OrderPage from "./pages/OrderPage";
import Contact from "./pages/Contact";
import Shop from "./pages/Shop";
import LegalPage from "./pages/LegalPage";
import Checkout from "./pages/Checkout";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProductPage />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/:slug" element={<OrderPage />} />
          <Route path="/thankyou/:id" element={<ThankYou />} />
          <Route path="/legal/:slug" element={<LegalPage />} />
          <Route path="/category/:id" element={<SingleCategory />} />
          <Route path="/contact" element={<Contact />} />
           <Route path="/checkout" element={<Checkout />} />
          
          <Route path="/dashboard" element={
            <PrivateRoute allowedRoles={["admin", "moderator"]}>
              <Dashboard />
            </PrivateRoute>
          } />
          
        </Routes>
      </Router>
    </div>
  );
}

export default App;